import { useForm } from "@mantine/form"
import type { TFunction } from "i18next"
import merge from "lodash/merge"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import type { TFormStep } from "../types"

export function useStepsForm<T = any>(steps: TFormStep[], props) {
  const { t } = useTranslation()
  const [step, setStep] = useState(0)
  const form = useForm({
    initialValues: merge({}, ...steps.map((step) => (step.initialValues ? step.initialValues(props) : {}))) as T,
    validate: validateSteps(steps, step, t),
    validateInputOnBlur: true,
    validateInputOnChange: true,
    transformValues: (values) => {
      return steps.reduce((acc, Step) => {
        const transform = Step.transformValues
        return transform ? transform(acc) : acc
      }, values)
    },
  })
  return { step, setStep, form }
}

function validateSteps(steps: TFormStep[], stepIndex: number, t: TFunction) {
  return (values: any) => {
    const currentStep = steps[stepIndex]
    return currentStep?.validate ? currentStep.validate(values, t) : {}
  }
}
